/* import __COLOCATED_TEMPLATE__ from './edit-button.hbs'; */
/** RESPONSIBLE TEAM: team-proactive-support **/
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';

interface Args {}

interface Signature {
  Args: Args;
}

export default class EditButton extends Component<Signature> {
  @service declare contentEditorService: any;
  @service declare appService: AppService;

  get customBot() {
    return this.contentEditorService.activeObject;
  }

  get customBotData() {
    return this.customBot?.botData;
  }

  get disabled() {
    if (this.customBotData?.isProcedure && !this.appService.app.canUseProceduresClosedBeta) {
      return true;
    }

    return (
      (this.contentEditorService.ruleset.isLive || this.contentEditorService.ruleset.isPaused) &&
      this.contentEditorService.ruleset.isMatchBehaviorStatic
    );
  }

  get isDisabledDueToProcedure() {
    return this.customBotData?.isProcedure;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentEditor::Headers::ViewMode::EditButton': typeof EditButton;
    'content-editor/headers/view-mode/edit-button': typeof EditButton;
  }
}
